export const iconFontAwesomeUsersPeoplePeopleLine = (
	<i className="fa-solid fa-people-line"></i>
);
